<template>
  <div v-bind="$attrs"
       v-on="$listeners">
    <div :style="containerStyle">
      <slot />
    </div>
  </div>
</template>

<script>
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'LabelPrimary',
    inheritAttrs: false,
    data: function () {
      return {
        containerStyle: {
          fontSize: FontStyle.size.sm,
          fontWeight: FontStyle.weight.xl,
          margin: `0 0 ${Layout.space.sm} 0`,
        },
      };
    },
    created: function () {
      this.containerStyle = {
        ...this.containerStyle,
        color: this.color.dark3(),
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
    },
  };
</script>
